<template>
  <div>
    <sheriff-elevador-responsive-image :sheriff="sheriff"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SheriffElevadorResponsiveImage from "./SheriffElevadorResponsiveImage";
export default {
  computed: {
    ...mapState(["sheriff"])
  },
  components: {
    SheriffElevadorResponsiveImage
  }
};
</script>

<style scoped>
</style>
